import * as React from "react";
import * as $ from 'jquery'
import {useEffect, useState} from "react";
import {Loader} from "./Loader";
import formatDate from "../utils/DateFormat";
import Skeleton from "react-loading-skeleton";

interface BlogPost {
    link: string
    title: string
    description: string
    date: Date
    type: "Qiita" | "Hatena"
}

interface BlogResponse {
    status: number,
    count: number,
    posts: BlogPost[]
}

const initialState: BlogResponse = {status: 0, count: 0, posts: []};

export const Blogs : React.FC<{}> = () => {
    const [blogs, setBlogs] = useState<BlogResponse>(initialState);
    const [index, setIndex] = useState<number>(5);

    function receiveData() {
        let results: BlogPost[] = [];
        $.ajax("https://cors-anywhere.herokuapp.com/https://qiita.com/br_branch/feed.atom", {
            type: "get"
        }).done((data) => {
            Array.prototype.push.apply(results, parseQiita(data));
            $.ajax("https://brbranch.hatenablog.jp/rss", {
                type: "get"
            }).done((data) => {
                Array.prototype.push.apply(results, parseHatena(data));
                sortAndSet(results);
            }).fail(() => {
                sortAndSet(results);
            });
        }).fail(() => {
            setBlogs({status: 500, count: 0, posts: []})
        });
    }

    function sortAndSet(data: BlogPost[]) {
        const res = data.sort((a, b) => {return b.date.getTime() - a.date.getTime()})
        setBlogs({status: 200, count: res.length, posts: res})
    }

    function parseHatena(data: XMLDocument): BlogPost[] {
        const entries = data.getElementsByTagName("item");
        const length = entries.length;
        const result: BlogPost[] = [];
        for(var i = 0; i < length; i++) {
            const item = entries.item(i);
            result.push({
                link: item.getElementsByTagName("link").item(0).textContent,
                description: item.getElementsByTagName("description").item(0).textContent.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'').substr(0,80),
                title: item.getElementsByTagName("title").item(0).textContent,
                date: new Date(Date.parse(item.getElementsByTagName("pubDate").item(0).textContent)),
                type: "Hatena"
            });
        }
        return result;
    }

    function parseQiita(data: XMLDocument): BlogPost[] {
        const entries = data.getElementsByTagName("entry");
        const length = entries.length;
        const result: BlogPost[] = [];
        for(var i = 0; i < length; i++) {
            const item = entries.item(i);
            result.push({
                link: item.getElementsByTagName("url").item(0).textContent,
                description: item.getElementsByTagName("content").item(0).textContent.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'').substr(0,80),
                title: item.getElementsByTagName("title").item(0).textContent,
                date: new Date(Date.parse(item.getElementsByTagName("published").item(0).textContent)),
                type: "Qiita"
            });
        }
        return result;
    }

    useEffect(() => {
        receiveData();
    }, [initialState]);

    function showBlogs() {
        if(blogs.status === 200) {
            const more = index >= blogs.count ? null : (
                <a className="panel-block is-active" onClick={() => {setIndex(index + 5)}}>
                    <div className={"arrow"}/>More
                </a>
            );
            return (
                <div className={"panel"}>
                    {blogs.posts.slice(0, index).map(showPost)}
                    {more}
                </div>
            )
        }

        function showError() {
            if(blogs.status === 200 || blogs.status === 0) {
                return null;
            }

            return (
                <div className="notification is-danger">データ取得に失敗しました。 <a href={"https://twitter.com/br_branch"} target={"_blank"}>Twitter</a>で教えてもらえると嬉しいです。</div>
            );
        }


        const maps = [0,1,2,3,4];
        return (
            <React.Fragment>
                {maps.map(e => {
                    return (
                        <a className="panel-block" target={"_blank"} key={"post-" + e}>
                            <span className="panel-icon ">
                              <i className="fas fa-book is-medium" aria-hidden="true"/>
                            </span>
                            <div className={"blog-post"}>
                                <div className={"blog-title"}><Skeleton width={200}/></div>
                                <div className={"blog-description"}><Skeleton count={2}/></div>
                                <div className={"blog-date"}><Skeleton width={200}/></div>
                            </div>
                        </a>
                    )
                })}
                <a className="panel-block is-active">
                    <Loader/>
                </a>
                {showError()}
            </React.Fragment>
        )
    }

    function showPost(blog: BlogPost, i: number) {
        return (
            <a className="panel-block is-active" href={blog.link} target={"_blank"} key={"post-" + i}>
                <span className="panel-icon ">
                  <i className="fas fa-book is-medium" aria-hidden="true"/>
                </span>
                <div className={"blog-post"}>
                    <div className={"blog-title"}>{blog.title}</div>
                    <div className={"blog-description"}>{blog.description}...</div>
                    <div className={"blog-date"}><span className={"blog-type blog-" + blog.type}>{blog.type}</span>投稿日：{formatDate(blog.date)}</div>
                </div>
            </a>
        )
    }

    return (
        <div className={`container works-root`}>
            <h1 className={"title"}>Blog</h1>
            {showBlogs()}
        </div>
    );
};
